import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class LicenseTicketApi extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Registers';
  controllerName = 'LicenseTickets';
  paging = 'paging';
  update = 'update';

  async getPaging(model,loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.paging].join('/'),
      data: model,
    };
    let res = httpClient.postAsync(request, loading);
    return res;
  }

  async getDetailTicket(id) {
    let request = {
      url: [this.getAPIUrl(), id].join('/'),
    };
    let res = httpClient.getAsync(request);
    return res;
  }

  async updateTicket(model) {
    let request = {
      url: [this.getAPIUrl(), this.update].join('/'),
      data: model,
    };
    let res = httpClient.putAsync(request);
    return res;
  }
}

export default new LicenseTicketApi();
